import generatorSmall from "assets/images/banner/generator/small.jpg";
// import generatorMedium from "assets/images/banner/generator/medium.jpg";
import generatorMain from "assets/images/banner/generator/main.jpg";

export interface BannerItem {
  small: string;
  medium: string;
  main: string;
  smallBg: string;
  mediumBg: string;
  mainBg: string;
}

interface Banners {
  [k: number]: BannerItem;
}

export const banners: Banners = {
  60: {
    small: generatorSmall,
    medium: generatorSmall,
    main: generatorMain,
    smallBg: "#000",
    mediumBg: "#000",
    mainBg: "#000",
  },
};

export default banners;
